import React from 'react';
import './styles.scss';
import { Container, Image, Stack } from 'react-bootstrap';
import { IMAGE_PATHS } from 'constants/imagePaths';
import { Link } from 'react-router-dom';
import useTranslate from 'hooks/useTranslate';
import {
	FACEBOOK_URL,
	TWITTER_URL,
	LINKEDIN_URL,
	INSTAGRAM_URL,
	YOUTUBE_URL,
	TIKTOK_URL,
	USER_TYPES,
} from 'constants/index';
import useAuthStore from 'store/auth';

const Footer: React.FC = () => {
	const { translate } = useTranslate();
	const { user: authUser }: Record<string, any> = useAuthStore((state) => state.userInfo ?? {});
	return (
		<>
			<section className="footer py-80 bg-white">
				<Container fluid>
					<div className="footer-inner d-flex flex-column flex-md-row">
						<div className="jobstas-intro">
							<Link to="/">
								<Image src={IMAGE_PATHS.JobstasLogo} alt="brand-logo" loading="lazy" />
							</Link>
							<h6 className="mb-0">{translate('Footer.footerDescription')}</h6>
						</div>
						<Stack className="menus text-md-center">
							<Link to="blogs">{translate('Footer.blog')}</Link>
							{authUser && authUser?.userType === USER_TYPES?.SEEKER && (
								<Link to="job-search?keyword=&cityId=&stateId=&countryId=&location=&industryId=">
									{translate('Footer.browseAJob')}
								</Link>
							)}
							<Link to="how-it-works">{translate('Footer.howItWorks')}</Link>
							<Link to="imprint">{translate('Footer.imprint')}</Link>
							<Link to="about">{translate('Footer.aboutUs')}</Link>
						</Stack>
						<Stack className="menus text-md-center">
							<Link to="privacy-policy">{translate('Footer.privacyPolicy')}</Link>
							<Link to="california-privacy-policy">
								{translate('Footer.californiaPrivacyPolicy')}
							</Link>
							<Link to="european-privacy-policy">{translate('Footer.europeanPrivacyPolicy')}</Link>
							<Link to="terms-conditions">{translate('Footer.termsConditions')}</Link>
						</Stack>
						<Stack className="menus text-md-center">
							<Link to="contact-us">{translate('Common.contact')}</Link>
							<Link to="faqs">{translate('Footer.fAQ')}</Link>
							<Link to="cancellation-policy">{translate('Footer.cancellationPolicy')}</Link>
							<Link to="cookies-policy">{translate('Footer.cookiesPolicy')}</Link>
						</Stack>
						<Stack className="menus text-md-center">
							<h6 className="fw-semibold mb-0">{translate('Footer.followUs')}</h6>
							<div className="d-flex flex-row flex-md-column gap-2 gap-md-3">
								<div className="social-links d-flex gap-2 gap-md-3 justify-content-md-center">
									<a
										href={FACEBOOK_URL}
										className="rounded-circle"
										target="_blank"
										rel="noopener noreferrer"
										aria-label="FACEBOOK_URL"
									>
										<i className="ri-facebook-fill"></i>
									</a>
									<a
										href={TWITTER_URL}
										className="rounded-circle"
										target="_blank"
										rel="noopener noreferrer"
										aria-label="TWITTER_URL"
									>
										<i className="ri-twitter-x-fill"></i>
									</a>
									<a
										href={LINKEDIN_URL}
										className="rounded-circle"
										target="_blank"
										rel="noopener noreferrer"
										aria-label="LINKEDIN_URL"
									>
										<i className="ri-linkedin-fill"></i>
									</a>
								</div>
								<div className="social-links d-flex gap-2 gap-md-3 justify-content-md-center">
									<a
										href={INSTAGRAM_URL}
										className="rounded-circle"
										target="_blank"
										rel="noopener noreferrer"
										aria-label="INSTAGRAM_URL"
									>
										<i className="ri-instagram-fill"></i>
									</a>
									<a
										href={YOUTUBE_URL}
										className="rounded-circle"
										target="_blank"
										rel="noopener noreferrer"
										aria-label="YOUTUBE_URL"
									>
										<i className="ri-youtube-fill"></i>
									</a>
									<a
										href={TIKTOK_URL}
										className="rounded-circle"
										target="_blank"
										rel="noopener noreferrer"
										aria-label="TIKTOK_URL"
									>
										<i className="ri-tiktok-fill"></i>
									</a>
								</div>
							</div>
						</Stack>
					</div>
				</Container>
			</section>
			<div className="footer-bottom text-center">
				<p className="text-white mb-0">
					{translate('Footer.jobstasAllReserved', { field: new Date().getFullYear().toString() })}
				</p>
			</div>
		</>
	);
};

export default Footer;
